function hamburgerMenuInit() {
    const menuHamburgerElement = document.querySelector('.top-header__hamburger');
    const menuElement = document.querySelector('.top-header');

    function showOrHideMenu() {
        menuHamburgerElement.classList.toggle('top-header__hamburger--active');
        menuElement.classList.toggle('top-header--sticky');
    }

    menuHamburgerElement.addEventListener('click', showOrHideMenu);
}

function toggleProperties(event) {
    let target = event.target;
    // if (!target.classList.contains('kt-title-item') || !target.classList.contains('kt-title-text')) {
    //     return;
    // }

    const tabElement = document.querySelector('#tab-waciwoci');
    // console.log('tabElement', tabElement);
    // if (!tabElement) {
    //     return;
    // }
    const propertiesElement = document.querySelector('.properties');
    propertiesElement.style.display = tabElement.classList.contains('kt-tab-title-inactive') ? 'none' : 'block';
}

function propertiesGlucometrInit() {
    const tabsElements = document.querySelector('.kt-tabs-title-list');

    if (tabsElements) {
        tabsElements.addEventListener('click', toggleProperties);
    }
}

function stickyMenuInit() {
    const topNavMenu = document.querySelector('.top-header');
    const body = document.querySelector('body');
    if (!topNavMenu) {
        return;
    }

    const topNavMenuHeight = topNavMenu.offsetHeight;
    const topNavMenuStickyClassName = 'top-header--sticky';

    document.addEventListener('scroll', (event) => {
        let scrollPosition = window.scrollY;
        if (scrollPosition > window.innerHeight) {
            topNavMenu.classList.add(topNavMenuStickyClassName);
            body.style.paddingTop = `${topNavMenuHeight}px`;
        } else {
            topNavMenu.classList.remove(topNavMenuStickyClassName);
            body.style.paddingTop = '0';
        }
    });
}

function handleFormFileInput() {
const body = document.body;
const fileInputClassName = 'wpcf7-file';
body.addEventListener('change', ({target}) => {
    const {type, classList, files} = target;


    if (type === 'file' && classList?.contains(fileInputClassName)) {
        const parent = target?.parentElement;
        const fileName = files[0]?.name;

        if (!parent || !fileName) {
            return;
        }

        parent.style = `--file-name: '${fileName}'; background: #713666; border-color: #713666; color: #fff;`;
    }
})
}

(function init() {
    hamburgerMenuInit();
    propertiesGlucometrInit();
    handleFormFileInput();
    //stickyMenuInit();
})();